import { render, staticRenderFns } from "./popularBar.vue?vue&type=template&id=f286bf2e&scoped=true&"
import script from "./popularBar.vue?vue&type=script&lang=js&"
export * from "./popularBar.vue?vue&type=script&lang=js&"
import style0 from "./popularBar.vue?vue&type=style&index=0&id=f286bf2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f286bf2e",
  null
  
)

export default component.exports